import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { keys } from "./auth-service-tools168.js";
import { px } from "./auth-service-tools171.js";
import { em } from "./auth-service-tools172.js";
import "react";
import { useMantineStyleNonce } from "./auth-service-tools199.js";
import { useMantineTheme } from "./auth-service-tools196.js";

function MantineClasses() {
  const theme = useMantineTheme();
  const nonce = useMantineStyleNonce();
  const classes = keys(theme.breakpoints).reduce((acc, breakpoint) => {
    const isPxBreakpoint = theme.breakpoints[breakpoint].includes("px");
    const pxValue = px(theme.breakpoints[breakpoint]);
    const maxWidthBreakpoint = isPxBreakpoint ? `${pxValue - 0.1}px` : em(pxValue - 0.1);
    const minWidthBreakpoint = isPxBreakpoint ? `${pxValue}px` : em(pxValue);
    return `${acc}@media (max-width: ${maxWidthBreakpoint}) {.mantine-visible-from-${breakpoint} {display: none !important;}}@media (min-width: ${minWidthBreakpoint}) {.mantine-hidden-from-${breakpoint} {display: none !important;}}`;
  }, "");
  return /* @__PURE__ */jsxRuntimeExports.jsx("style", {
    "data-mantine-styles": "classes",
    nonce: nonce == null ? void 0 : nonce(),
    dangerouslySetInnerHTML: {
      __html: classes
    }
  });
}

export { MantineClasses };